import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { ResellerSBC } from '@app/core/interfaces/sbc';
import { Utils } from '@app/shared/services/utils.service';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { UserLevel } from '../models/user-level';

@Injectable({
  providedIn: 'root',
})
export class SBCRepository {
  constructor(
    private authService: AuthenticationService,
    private http: HttpClient,
    private utils: Utils
  ) {}

  listResellerSBCs(): Observable<ResellerSBC[]> {
    const urls = {
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.ServiceProvider + '/resellerSBCs',
      [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.Enterprise + '/resellerSBCs',
      [UserLevel.EndUser]:
        (this.authService.userIsEndUser() === true ? BaseUrls.EndUser : BaseUrls.Enterprise.Enterprise) +
        '/resellerSBCs',
    };
    return this.utils.apiUrl(urls).pipe(mergeMap((url) => this.http.get<ResellerSBC[]>(url)));
  }
}
